import './Modal.css'
import '../videoDownload/VideoDownload.css'

const Modal = ({closeModal, title, content, buttonPrhase}) => {
    return(
        <div className='modal-container'>
            <div className='use-terms-box'>
                <div className='terms-title'>
                    <h1>{title}</h1>
                </div>
                <hr/>
                <div className='terms-content'>
                    <p>
                        {content}
                    </p>
                </div>
                    <button className='download-button' onClick={closeModal}>{buttonPrhase}</button>
            </div>
        </div>
    )
}

export default Modal